import { useState, useCallback } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useGetCampaignSubCampaigns = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [subCampaigns, setSubCampaigns] = useState([]);

    const getCampaignSubCampaigns = useCallback(async (masterId) => {
        if (!masterId) {
            toast.error("Master campaign ID is required.");
            return;
        }

        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "getCampaignSubCampaigns",
                masterId: masterId,
            });

            const campaigns = response.data.campaigns || response.data.liste || response.data.subCampaigns || [];

            setSubCampaigns(campaigns);
            return campaigns;
        } catch (err) {
            toast.error(apiErrorText(err));
            setError(err);
            setSubCampaigns([]);
            throw err;
        } finally {
            setLoading(false);
        }
    }, []);

    const clearSubCampaigns = useCallback(() => {
        setSubCampaigns([]);
        setError(null);
    }, []);

    return { loading, error, subCampaigns, getCampaignSubCampaigns, clearSubCampaigns };
};

export default useGetCampaignSubCampaigns;
